@if (auth.hasPermission('report.activity_by_date:Read')) {
  <app-status-panel label="Auto-Cleared" statusKey="processingStatusAutoCleared" />
}
